@use 'styles/functions/rem' as *;

.withFeatureAccess {
    grid-template-columns: max-content;
}

.showCrown {
    grid-template-columns: minmax(0, rem(16px)) max-content;
}
